import { defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy } from '@chakra-ui/react/anatomy';

import { modalContentMaxWidth, modalSizes, type ModalSize } from './modal.kds';

const modalSizeStyles = (size: ModalSize) => ({
  content: {
    maxW: modalContentMaxWidth[size],
  },
});

/** KDS Modal slot recipe (Chakra `dialog` anatomy). */
export const modalSlotRecipe = defineSlotRecipe({
  slots: dialogAnatomy.keys(),
  base: {
    backdrop: {
      zIndex: 'modal',
    },
    content: {
      bg: 'neutral.0',
      borderRadius: 'sm',
      display: 'flex',
      flexDirection: 'column',
      // Absolute CloseTrigger anchors to content.
      position: 'relative',
      maxH: 'calc(100dvh - 2 * var(--dialog-base-margin, var(--ks-spacing-16)))',
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1',
      ps: '6',
      // CloseTrigger is absolute (insetEnd 6 + IconButton rg 32) — pe must clear it
      // so long titles (e.g. review nudge) do not run under the X.
      pe: '16',
      py: '4',
    },
    body: {
      px: '6',
      pt: '3',
      pb: '4',
      flex: '1 1 auto',
      minH: '0',
      overflowY: 'auto',
    },
    footer: {
      px: '6',
      py: '4',
      flexShrink: 0,
    },
    title: {
      textStyle: 'h5.medium',
      color: 'neutral.500',
    },
    description: {
      textStyle: 'default.regular',
      color: 'neutral.350',
    },
    closeTrigger: {
      minW: 'initial',
      position: 'absolute',
      top: '4',
      insetInlineEnd: '6',
    },
  },
  variants: {
    size: Object.fromEntries(modalSizes.map(size => [size, modalSizeStyles(size)])) as Record<
      ModalSize,
      ReturnType<typeof modalSizeStyles>
    >,
  },
  defaultVariants: {
    size: 'md',
  },
});
